import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n";
import store from "./store";
import VueCookies from "vue-cookies";
import './styles/main.scss';

import { db, messaging } from "./firebase";
// No longer registered: /service-worker.js (the old Workbox cache) and
// /firebase-messaging-sw.js both claimed the site's root and kept replacing
// each other. The push notification worker below is the only one now.
// import './registerServiceWorker'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueJsonLD from 'vue-jsonld'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import '../node_modules/@fortawesome/fontawesome-free/js/all.js'
import VueMeta from 'vue-meta'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueSocialSharing from 'vue-social-sharing'
import { AffiliatesActions, AffiliatesGetters, UserActions } from "./store/Storetypes.js";
import { isSignedIn } from "./utils/accountHome";
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import OneSignalPlugin from "./plugins/onesignal";

Vue.use(OneSignalPlugin, { store });

window.vueRouter = router;
Vue.use(VueTelInput, {
  mode: 'international',
  onlyCountries: [],
})

export const swReady = new Promise((resolve) => {
  if ('serviceWorker' in navigator) {
        // A new service worker took over: reload once so the page and the
    // worker match. Once per tab, so it can never loop.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      try {
        if (window.sessionStorage.getItem('guiders.swReloaded')) return;
        window.sessionStorage.setItem('guiders.swReloaded', '1');
      } catch (e) {
        return;
      }
      window.location.reload();
    });

    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
        console.log('Service worker registered:', registration.scope);
        if (messaging) messaging.useServiceWorker(registration);
        resolve(registration);
      })
      .catch((err) => {
        console.error('Service worker registration failed:', err);
        resolve(null);
      });
  } else {
    resolve(null);
  }
});

Vue.use(VueSocialSharing);

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(Buefy, { defaultIconPack: 'fas' })
Vue.config.productionTip = false;
Vue.use(VueCookies);
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})
Vue.use(VueJsonLD)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAgZ3R7nwmd08kbQPr9LpTUATBMf8Dg0-o',
    libraries: 'places',
  },
})

// Check referral expiry periodically
setInterval(() => {
  const expiry = store.getters[AffiliatesGetters.GET_REFERRAL_EXPIRY]
  if (expiry && expiry < Date.now()) {
    store.dispatch(AffiliatesActions.CLEAR_REFERRAL)
  }
}, 3600000)

let app;

// Build-time pre-rendering (vue.config.js) saves each page once it fires
// "render-event". Firing too early saves an empty or "Loading..." page,
// which is what search engines then see. So wait until the page is really
// there: its own title is set, it has a main heading, and nothing has
// changed for a moment (data loaded). Only runs while pre-rendering.
function signalWhenPageIsReady() {
  if (!window.__PRERENDER_INJECTED) return;
  const started = Date.now();
  let lastSize = -1;
  let stableSince = Date.now();
  const timer = setInterval(() => {
    const size = document.body.innerHTML.length;
    if (size !== lastSize) {
      lastSize = size;
      stableSince = Date.now();
    }
    const title = (document.title || "").trim();
    const heading = [...document.querySelectorAll("h1")].map((h) => h.textContent.trim()).find(Boolean);
    const hasOwnTitle = title && title !== "Guiders" && title !== "Guiders.pt" && !/loading/i.test(title);
    const hasContent = heading && !/loading/i.test(heading);
    const settled = Date.now() - stableSince > 1200;
    if ((hasOwnTitle && hasContent && settled) || Date.now() - started > 20000) {
      clearInterval(timer);
      document.dispatchEvent(new Event("render-event"));
    }
  }, 200);
}

// Firebase Auth check before mounting
db.auth().onAuthStateChanged((firebaseUser) => {
  // The store is saved in this browser (vuex-persistedstate), so it can
  // still hold an account after the Firebase session has ended (expired,
  // signed out in another tab...). Clear it, so the headers don't show the
  // account menu to someone who isn't signed in.
  if (!firebaseUser && isSignedIn(store.state.users)) {
    store.dispatch(UserActions.RESET_STATES);
  }
  if (!app) {
    app = new Vue({
      el: '#app',
      router,
      store,
      i18n,
      render: (h) => h(App),
      mounted() {
        router.onReady(signalWhenPageIsReady);
      },
    })
  }
});